import { ref } from 'vue';
import { useMagicKeys, whenever } from '@vueuse/core';
import { getAuthExpirationTimestamp, isWebviewContext, mobileAppAuthorizationFailed } from '../utils/webview';

const isWebView = ref(isWebviewContext());
const appAuthorizationFailed = ref(mobileAppAuthorizationFailed());
const authExpirationTimestamp = ref(getAuthExpirationTimestamp());

/**
 * Register a small dev helper that allows switching view context at runtime, if we're in a safe environment
 */
if (import.meta.env.DEV || import.meta.env.VITE_APP_ENV === 'staging') {
    const switchContext = () => {
        isWebView.value = !isWebView.value;
        // eslint-disable-next-line no-console
        console.info(`Switched context to:`, isWebView.value ? 'webview' : 'web');
    };

    // eslint-disable-next-line no-console
    console.info('Press Ctrl + Shift + K to switch contexts between Web + Webview');
    const keys = useMagicKeys();
    const contextSwitchCombination = keys['Ctrl+Shift+K'];
    whenever(contextSwitchCombination, switchContext);
}

function deeplinkToAppRoute(appRoute = '') {
    window.location = `karriereapp://${appRoute}`;
}

export function useWebViewContext() {
    return {
        isWebView,
        appAuthorizationFailed,
        deeplinkToAppRoute,
        authExpirationTimestamp,
    };
}
